
<template>
<div style="background: rgb(244, 244, 244);">
 <div class="container" style="background:white">
  
  <navbarbg/> 

  <div class="column is-one-quarter box-step pd-5 bgcolor">
  </div>
  <div class="column" >
       <div class="columns">
            <div class="column"></div>
            <div v-if="!forgetpass" class="column is-four-fifths marginmobile signin">
         <span class="fontbold2">Reset Password</span>   
        <div >
        <b-field label="New Password" style="margin-top:40px;">
            <b-input class="fontnormal" placeholder="New Password"  v-model="pass.newpass" type="password" ></b-input>
        </b-field>
        <b-field label="Re Password">
            <b-input class="fontnormal"  @keyup.native.enter="signin_c" type="password"  placeholder="Re Password" v-model="pass.repass"></b-input>
        </b-field>
       
         <br>
         <div class="buttons">
          <a @click="changepassword()" class="button is-primary buttonc">
            <span class="fontbold">Change Password</span>
          </a>
        </div>
      
            </div>
             </div>
             
              <div class="column"></div>
             </div>
  </div>
</div>
  </div>
</template>

<script>
import {HTTP,HTTPMentor} from "@/axios.js";
import navbarbg from './navbarbg'

export default {
        data() {
            return {
                pass:{
                    newpass: '',
                    repass:'',
                },
            }
        },
        computed:{
        },
        methods:{
         gopath(val){
             this.$router.push(val)
        },
        changepassword(){
            // console.log(this.rememberpass)
            // this.pass = this.rememberpass
            // return
           if(!this.pass.newpass || !this.pass.repass){
              this.$dialog.alert('<p class="has-text-centered is-size-5">Please type in all required fields</p>');
              return
           }
           if(this.pass.newpass != this.pass.repass){
              this.$dialog.alert('<p class="has-text-centered is-size-5">New Password and Re-password <br> do not match</p>');
               return
           }else{

             HTTPMentor.defaults.headers.common.Authorization = `Bearer ${this.$route.params.token}`;
            HTTPMentor.post(`forgot/password`,{passNew : this.pass.newpass })
              .then(res => {
              console.log('forgot/password', res.data)
              
              if(res.data.success){
                this.signup = {}
                console.log('res.data.obj',res.data.obj)
                this.$dialog.alert('<p class="has-text-centered is-size-5">Change Password Successfully</p>');
                this.pass = {}
               }else{
                this.pass = {}
                this.$dialog.alert(`<p class="has-text-centered is-size-5">${res.data.message}</p>`);
              }
            })
            .catch(e => {
              console.log("api/add/kpi/error",e);
                this.$dialog.alert('<p class="has-text-centered is-size-5">Please check your network connection</p>');
                this.pass = {}
            });
          }

        }
    },
    components:{
        navbarbg
    },
    mounted() {
        },
    computed: {
    },
}
</script>
<style scoped>


.bgcolor{
    /* background-color: ; */
  background:#0d6aca url("../assets/Intersect_bg.png");
    overflow:hidden !important;border-color:white !important;
    /* background-image: ; */
    min-height: 100vh;
    background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.box-step{
        /* border-right: solid; */
        border-right-width: 1px;
        border-color: #dbdbdb;
}


.forgot{
    float: right;
  position: relative; bottom: 3px;color:#0FB9F4;
}
.column.bgcolor{
  float: left;
  width: 25%;
    min-width: 130px !important;
    min-height: 101.5vh;
}
.tems{
    position: relative; bottom: 3px;color:rgb(165,229,251);
}
.fontnormal{
  font-family: 'Raleway';
font-size: 14px;
color: white;
}
.fontbold2{
    font-size: 30px;
    color: black;
}
.container{
        text-align: initial;
}
#fullheight{
    margin: 0;
    height: 100vh;
    overflow: hidden;
}
.backgroundleft{
    background-image: linear-gradient(#0d6aca, #0fb7f3);
    margin: 0;
}
.buttonc{
  padding-left: 2rem;
    padding-right: 2rem;
  background: linear-gradient(180deg, #FD7900 -34.44%, #FFCB2A 133.33%);
  border-radius: 40px;
}

   
  .columns{
    margin:0;
        height: 100vh;
    overflow: hidden;
    display: flex;
  }

  


@media only screen and (max-width: 499px) {
span.forgot{
  display: block;
  float: inherit;
}
}




@media screen and (min-width: 1472px){
.container {
    max-width: 1150px;
    width: 1150px;
}
}

/* mobile */
.menutop_mobile .fontbold2{
    display: none
}
.circlehamburger{
    display: none;
    height: 50px;
    width: 50px;
    position: fixed;
    background: #0d6aca;
    color: white;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    top: 5px;
    right: 5px;
    transition: all 0.5s;
    z-index: 100;
}
.widthmenu{
width:90%;float:right;
}

.column.is-four-fifths{
        margin-top: 10px;
    }
@media only screen and (max-width: 951px) {
    .columns{
    display: block;
}
div.control{
  width: 100%;
}
    .column.is-four-fifths{
        margin-top: 75px;
    padding: 22px;
    }
    div.column.is-one-quarter.box-step.pd-5.bgcolor{
    min-height: 200px;
    min-width: 390px;
    position: absolute;
    right: 2px;
    z-index: 88;
    border-radius: 20px;
    transform: scaleX(0);
      top: -300px;
    transition: all 0.5s;
    opacity: 0;
}
       .menutop_mobile .fontbold2{
    display: block
	}
 .circlehamburger{
    display: flex;
}
.menutop_mobile{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 4rem;
    background: #0d6aca;
    z-index: 99;
    transition: all 0.5s;
}

.openprofile{
    top: 70px !important;
    opacity: 1 !important;
    transform: scaleX(1)!important;
}
}
@media only screen and (max-width: 400px) {
    div.column.is-one-quarter.box-step.pd-5.bgcolor{
       width: 355px;
           min-width: 366px;
    }
    .widthmenu{
    width: 100%;
    }
}
</style>

